import React, { useState } from "react";
import { Image, Select, SelectItem } from "@nextui-org/react";
import { useNavigate } from "react-router-dom";

function ImageSelect({ items, type, initialProduct, initialStyle, setPromptRequest }) {
  // State to track the selected item
  const [selectedName, setSelectedName] = useState(() => {
    if (type === "model") {
      return items.length > 0 ? initialProduct : items[0].name;
    } else if (type === "styles") {
      return items.length > 0 ? initialStyle : items[0].name;
    }
    return items[0].id;
  });

  const navigate = useNavigate();

  return (
    <div className="flex items-center gap-5">
      <div className="flex h-[70px] w-[70px] flex-shrink-0 items-center justify-center">
        <Image src={(items.find((item) => item.name === selectedName) || items[0]).thumbnail} radius="sm" alt="Selected Item" />
      </div>
      <Select
        selectedKeys={[selectedName]}
        isRequired={true}
        onSelectionChange={(val) => {
          const newSelectedName = Array.from(val)[0] || items[0].name;
          setSelectedName(newSelectedName);
          // Find the new selected item based on newSelectedId
          const newSelectedItem = items.find((item) => item.name === newSelectedName);
          if (type === "model" && newSelectedItem) {
            setPromptRequest({ model: newSelectedItem.lora_model_name, triggerWord: newSelectedItem.trigger_word });
            navigate(`/generate/model/${newSelectedName}`);
          } else if (type === "styles" && newSelectedItem) {
            setPromptRequest({ keywords: newSelectedItem.keywords.split(",") });
          }
        }}
        aria-label="Select an item"
        radius="sm"
        variant="bordered"
        classNames={{
          value: ["group-data-[has-value=true]:text-white text-[18px] p-4"],
          selectorIcon: ["text-foreground-400"],
          trigger: ["h-[75px] border-default-400 data-[hover=true]:border-default-500"],
        }}
      >
        {items.map((item) => (
          <SelectItem key={item.name} value={item.name}>
            {item.name}
          </SelectItem>
        ))}
      </Select>
    </div>
  );
}

export default ImageSelect;
